// src/Contact.js

import "../../styles/Contact.css";

import Label from "../atoms/Label";
import React from "react";
import backgroundImage from "../../assets/ic_contact_bg.svg";
import emailIcon from "../../assets/ic_email_blue.svg";
import locationIcon from "../../assets/ic_location_blue.svg";
import phoneIcon from "../../assets/ic_phone_blue.svg";

const Contact = () => {
	return (
		<div className='contact-container-wrapper'>
			<div className='contact-container' style={{ height: "auto" }}>
				<div className='contact-header'>
					<Label
						label='Get in Touch'
						fontSize={"31px"}
						color={"#FFFFFF"}
						fontWeight={"700"}
						textAlign='left'
					/>
					<Label
						label='Want to get in touch? We would love to hear from you. Here is how you can reach us...'
						fontSize={"16px"}
						color={"#FFFFFF"}
						fontWeight={"400"}
						textAlign='left'
					/>
				</div>
				<div className='contact-cards'>
					<div className='card' style={{ minHeight: "7.3rem" }}>
						<img src={locationIcon} alt='Location' className='icon' />
						<div className='card-content'>
							<Label
								label='Address'
								fontSize={"16px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
							{/* <Label label="Greer South Carolina, 29650" fontSize={"16px"}  color={"#000000"} fontWeight={"400"} textAlign="left"/> */}
							<Label
								label='Charlotte, North Carolina, 28173'
								fontSize={"16px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
							<Label
								label='United States'
								fontSize={"16px"}
								color={"#000000"}
								fontWeight={"400"}
								textAlign='left'
							/>
						</div>
					</div>
					<a
						href='tel:+1512-921-9360'
						style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}>
						<div className='card' style={{ minHeight: "7.3rem" }}>
							<img src={phoneIcon} alt='Phone' className='icon' />
							<div className='card-content'>
								<Label
									style={{ cursor: "pointer" }}
									label='Phone'
									fontSize={"16px"}
									color={"#000000"}
									fontWeight={"400"}
									textAlign='left'
								/>
								<Label
									style={{ cursor: "pointer" }}
									label='+1512-921-9360'
									fontSize={"16px"}
									color={"#000000"}
									fontWeight={"400"}
									textAlign='left'
								/>
							</div>
						</div>
					</a>
					<a
						href='mailto:rahulrai@aibrilliance.com'
						style={{ textDecoration: "none", color: "inherit", cursor: "pointer" }}>
						<div className='card' style={{ minHeight: "7.3rem" }}>
							<img src={emailIcon} alt='Email' className='icon' />
							<div className='card-content' style={{ cursor: "pointer" }}>
								<Label
									style={{ cursor: "pointer" }}
									label='Email'
									fontSize={"16px"}
									color={"#000000"}
									fontWeight={"400"}
									textAlign='left'
								/>
								<Label
									style={{ cursor: "pointer" }}
									label='rahulrai@aibrilliance.com'
									fontSize={"16px"}
									color={"#000000"}
									fontWeight={"400"}
									textAlign='left'
								/>
							</div>
						</div>
					</a>
				</div>
			</div>
		</div>
	);
};

export default Contact;
